import React from 'react';
import messageEnum from './messageEnum';
import { useTranslation, Trans } from 'react-i18next';
import { getPlayerProperty } from './gameSlice';
import { useSelector } from 'react-redux';

const TransRaw = (props) => {
  return (
    <>
      {props.arg}
    </>
  );
}

export const Message = (props) => {
  const { t } = useTranslation();
  const args = props.args ?? {};

  const name = useSelector(state => getPlayerProperty(state, args.no ?? null, 'name'));

  switch (props.type) {
    case messageEnum.EXCHANGE_LETTERS: {
      return (
        <Trans t={t} i18nKey="MESSAGE.EXCHANGE_LETTERS" count={args.count}>
          <span className="player">{{player: name}}</span> bytte {{count: args.count}} bokstäver.
        </Trans>
      );
    }
    case messageEnum.RECONNECTED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.RECONNECTED">
          <span className="player">{{player: name}}</span> har kopplat upp igen.
        </Trans>
      );
    }
    case messageEnum.DISCONNECTED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.DISCONNECTED">
          <span className="player">{{player: name}}</span> har kopplat ned. Om denne inte kopplat upp igen inom fem minuter vinner du matchen! Spelet fortgår medan du väntar.
        </Trans>
      );
    }
    case messageEnum.TIMEOUT: {
      return (
        <Trans t={t} i18nKey="MESSAGE.TIMEOUT">
          Tiden har gått ut för <span className="player">{{player: name}}</span>!
        </Trans>
      );
    }
    case messageEnum.PASSED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.PASSED">
          <span className="player">{{player: name}}</span> passade.
        </Trans>
      );
    }
    case messageEnum.PAUSED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.PAUSED">
          Spelet är nu pausat (pausen avslutas automatiskt inom 10 minuter)
        </Trans>
      );
    }
    case messageEnum.UNPAUSED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.UNPAUSED">
          Spelet är nu igång igen efter pausen
        </Trans>
      );
    }
    case messageEnum.PAUSE_REQUEST: {
      if (args.choice) {
        return (
          <Trans t={t} i18nKey="MESSAGE.PAUSE_REQUEST_ON">
            <span className="player">{{player: name}}</span> har ansökt om att pausa spelet.
          </Trans>
        );
      }
      return (
        <Trans t={t} i18nKey="MESSAGE.PAUSE_REQUEST_OFF">
          <span className="player">{{player: name}}</span> har ansökt om att avbryta pausen.
        </Trans>
      );
    }
    case messageEnum.PAUSE_RESPONSE: {
      if (args.choice) {
        if (args.accept) {
          return (
            <Trans t={t} i18nKey="MESSAGE.PAUSE_RESPONSE_ON_ACCEPT">
              <span className="player">{{player: name}}</span> har accepterat pausen.
            </Trans>
          );
        }
        return (
          <Trans t={t} i18nKey="MESSAGE.PAUSE_RESPONSE_ON_REJECT">
            <span className="player">{{player: name}}</span> har ej accepterat pausen.
          </Trans>
        );
      }
      if (args.accept) {
        return (
          <Trans t={t} i18nKey="MESSAGE.PAUSE_RESPONSE_OFF_ACCEPT">
            <span className="player">{{player: name}}</span> har accepterat att avbryta pausen.
          </Trans>
        );
      }
      return (
        <Trans t={t} i18nKey="MESSAGE.PAUSE_RESPONSE_OFF_REJECT">
          <span className="player">{{player: name}}</span> har ej accepterat att avbryta pausen.
        </Trans>
      );
    }
    case messageEnum.TURN: {
      return (
        <Trans t={t} i18nKey="MESSAGE.TURN">
          <span className="player">{{player: name}}</span>:s tur.
        </Trans>
      );
    }
    case messageEnum.ROLLED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.ROLLED">
          <span className="player">{{player: name}}</span> har utfört en rullning och får {{points: args.points}} poäng extra!!!
        </Trans>
      );
    }
    case messageEnum.INCORRECT_WORDS: {
      const arg = (
        <span className="words">
          {args.words.map((w, i) => [
            i > 0 && ", ",
            <span key={i} className="word">{w.word}</span>
          ])}
        </span>
      )
      return (
        <Trans t={t} i18nKey="MESSAGE.INCORRECT_WORDS">
          Ej korrekta ord: <TransRaw arg={arg} />
        </Trans>
      );
    }
    case messageEnum.N_TRIES_LEFT: {
      return (
        <Trans t={t} i18nKey="MESSAGE.N_TRIES_LEFT" count={args.triesLeft}>
          Du har {{count: args.triesLeft}} försök kvar.
        </Trans>
      );
    }
    case messageEnum.WORDS: {
      const wordsArg = (
        <span className="words">
          {args.words.map((w, i) => [
            i > 0 && ", ",
            <span key={i} className="word">{w.word}</span>
          ])}
        </span>
      );
      let pointsArg = '';
      if (args.words.length > 1) {
        pointsArg = args.words.map(w => w.points.toString()).join('+')+'=';
      }
      const totalPoints = args.words.map(w => w.points).reduce((a, b) => a + b, 0);
      pointsArg += totalPoints.toString();

      return (
        <Trans t={t} i18nKey="MESSAGE.WORDS">
          <span className="player">{{player: name}}</span>: <TransRaw arg={wordsArg} /> (<TransRaw arg={pointsArg} />).
        </Trans>
      );
    }
    case messageEnum.MESSAGE: {
      return (
        <Trans t={t} i18nKey="MESSAGE.MESSAGE">
          <span className="player">{{player: name}}</span>: {{data: args.data}}
        </Trans>
      );
    }
    case messageEnum.GAVEUP: {
      return (
        <Trans t={t} i18nKey="MESSAGE.GAVEUP">
          <span className="player">{{player: name}}</span> gav up!
        </Trans>
      );
    }
    case messageEnum.MISSED_TRIES: {
      return (
        <Trans t={t} i18nKey="MESSAGE.MISSED_TRIES">
          <span className="player">{{player: name}}</span> missade alla sina försök.
        </Trans>
      );
    }
    case messageEnum.ENDGAME_DROP: {
      return (
        <Trans t={t} i18nKey="MESSAGE.ENDGAME_DROP">
          Eftersom <span className="player">{{player: name}}</span> lämnade/gav upp spelet i förtid vann övriga.
        </Trans>
      );
    }
    case messageEnum.ENDGAME_WINNER: {
      return (
        <Trans t={t} i18nKey="MESSAGE.ENDGAME_WINNER">
          Därmed vann <span className="player">{{player: name}}</span>!
        </Trans>
      );
    }
    case messageEnum.ENDGAME_DRAW: {
      return (
        <Trans t={t} i18nKey="MESSAGE.ENDGAME_DRAW">
          Det blev oavgjort
        </Trans>
      );
    }
    case messageEnum.BOGUS_CHARS_GIVEN: {
      return (
        <Trans t={t} i18nKey="MESSAGE.BOGUS_CHARS_GIVEN">
          De brickor du försökte använda har pga ett spelfel blivit oanvändbara, v.g. använd dem ej.
        </Trans>
      );
    }
    case messageEnum.NOT_ALLOWED_TO_SWAP: {
      return (
        <Trans t={t} i18nKey="MESSAGE.NOT_ALLOWED_TO_SWAP">
          Du får inte byta brickor med så få kvar i potten.
        </Trans>
      );
    }
    case messageEnum.OCCUPIED_SQUARE: {
      return (
        <Trans t={t} i18nKey="MESSAGE.OCCUPIED_SQUARE">
          Du har lagt en bricka på en redan upptagen ruta.
        </Trans>
      );
    }
    case messageEnum.START_IN_THE_MIDDLE: {
      return (
        <Trans t={t} i18nKey="MESSAGE.START_IN_THE_MIDDLE">
          Du måste börja på mittersta rutan.
        </Trans>
      );
    }
    case messageEnum.ONE_CHAR_WORD_NOT_ALLOWED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.ONE_CHAR_WORD_NOT_ALLOWED">
          Du kan ej lägga ord med endast en bokstav.
        </Trans>
      );
    }
    case messageEnum.NOT_ATTACHED_CHAR: {
      return (
        <Trans t={t} i18nKey="MESSAGE.NOT_ATTACHED_CHAR">
          Nya ord måste bygga på gamla; lägg brickorna bredvid varandra.
        </Trans>
      );
    }
    case messageEnum.NOT_IN_LINE: {
      return (
        <Trans t={t} i18nKey="MESSAGE.NOT_IN_LINE">
          Brickorna du lagt är ej i rak linje med varandra.
        </Trans>
      );
    }
    case messageEnum.WE_GOT_GAPS: {
      return (
        <Trans t={t} i18nKey="MESSAGE.WE_GOT_GAPS">
          Du måste lägga brickorna bredvid varandra.
        </Trans>
      );
    }
    case messageEnum.PAUSE_IN_PROGRESS: {
      return (
        <Trans t={t} i18nKey="MESSAGE.PAUSE_IN_PROGRESS">
          Spelet håller redan på att pausas, v.g vänta
        </Trans>
      );
    }
    case messageEnum.GAME_ENDED_ABRUPT: {
      return (
        <Trans t={t} i18nKey="MESSAGE.GAME_ENDED_ABRUPT">
          Spelet har avslutats utan att några ord har lagts.
        </Trans>
      );
    }
    case messageEnum.PLAYING_EMPTY_JOKER: {
      return (
        <Trans t={t} i18nKey="MESSAGE.PLAYING_EMPTY_JOKER">
          Du måste först välja bokstav på jokerbrickan!
        </Trans>
      );
    }
    case messageEnum.ENDGAME_SCORE: {
      let points = args.score;
      let pointsStr = args.score.toString();
      if (args.timeScore !== null) {
        points -= args.timeScore;
        pointsStr += '-'+args.timeScore.toString();
      }
      points += args.charScore;
      if (args.charScore < 0) {
        pointsStr += '-'+(-args.charScore).toString();
      } else {
        pointsStr += '+'+args.charScore.toString();
      }
      pointsStr += '='+points.toString();

      if (args.timeScore !== null) {
        if (args.charScore < 0) {
          return (
            <Trans t={t} i18nKey="MESSAGE.ENDGAME_SCORE_TIME_CHARMINUS">
              <span className="player">{{player: name}}</span> fick {{timeScore: args.timeScore}} poäng i tidsavdrag och {{charScore: -args.charScore}} poäng i avdrag för bokstäver kvar (<TransRaw arg={pointsStr} /> poäng)
            </Trans>
          );
        } else {
          return (
            <Trans t={t} i18nKey="MESSAGE.ENDGAME_SCORE_TIME_CHARPLUS">
              <span className="player">{{player: name}}</span> fick {{timeScore: args.timeScore}} poäng i tidsavdrag och {{charScore: args.charScore}} poäng extra för andra spelares bokstäver (<TransRaw arg={pointsStr} /> poäng)
            </Trans>
          );
        }
      } else {
        if (args.charScore < 0) {
          return (
            <Trans t={t} i18nKey="MESSAGE.ENDGAME_SCORE_CHARMINUS">
              <span className="player">{{player: name}}</span> fick {{charScore: -args.charScore}} poäng i avdrag för bokstäver kvar (<TransRaw arg={pointsStr} /> poäng)
            </Trans>
          );
        } else {
          return (
            <Trans t={t} i18nKey="MESSAGE.ENDGAME_SCORE_CHARPLUS">
              <span className="player">{{player: name}}</span> fick {{charScore: args.charScore}} poäng extra för andra spelares bokstäver (<TransRaw arg={pointsStr} /> poäng)
            </Trans>
          );
        }
      }
    }
    case messageEnum.ENDGAME_RATING: {
      const ratingChange = args.rating - args.oldRating;
      const ratingChangeStr = ratingChange >= 0 ? '+'+ratingChange : ratingChange;
      return (
        <Trans t={t} i18nKey="MESSAGE.ENDGAME_RATING">
          <span className="player">{{player: name}}</span> :s nya rating är {{rating: args.rating}} ({{ratingChange: ratingChangeStr}})
        </Trans>
      );
    }
    case messageEnum.SPY_JOINED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.SPY_JOINED">
          <span className="player">{{player: args.name}}</span> spionerar.
        </Trans>
      );
    }
    case messageEnum.SPY_PARTED: {
      return (
        <Trans t={t} i18nKey="MESSAGE.SPY_PARTED">
          <span className="player">{{player: args.name}}</span> har slutat spionera.
        </Trans>
      );
    }
    default:
      return null;
  }
}